import { useQuery } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';
import { ITaskType } from '../../Interfaces/ITaskType';
import { ITaskPriority } from '../../Interfaces/ITaskPriority';

// #1244 — Aufgabentypen/-prioritäten (Stammdaten). Die Aufgaben-Automationen
// selbst laufen über das Rechtsgeschäftsart-fullObject (kein eigener Endpoint).

export const useTaskTypes = () => {
  const { data: taskTypes } = useQuery<ITaskType[]>({
    refetchOnWindowFocus: false,
    queryKey: ['tasktype'],
    queryFn: () => customFetcher({ endpoint: '/tasktype' }),
  });
  return { taskTypes: taskTypes ?? [] };
};

export const useTaskPriorities = () => {
  const { data: taskPriorities } = useQuery<ITaskPriority[]>({
    refetchOnWindowFocus: false,
    queryKey: ['taskpriority'],
    queryFn: () => customFetcher({ endpoint: '/taskpriority' }),
  });
  return { taskPriorities: taskPriorities ?? [] };
};
